import { initialize } from "../src/custom_elements";

initialize();
